import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule as ACommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// import { AuthGuard } from './auth-guard';
// import { UserService } from './user.service';

import { TYTCommonModule } from '../common';
import { ApiModule } from '../api';
import { ValidationModule } from '../validation';
// import { LoginBounceComponent } from './login-bounce/login-bounce.component';
// import { routing } from './polls.routing';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PollSingleComponent } from './poll-single/poll-single.component';
import { FeaturedCardPollComponent } from './featured-poll-card/featured-card-poll.component';
import { CommonUiModule } from 'common-ui';
import { PollMobilePreviewComponent } from './poll-mobile-preview/poll-mobile-preview.component';

const COMPONENTS = [
  PollSingleComponent,
  FeaturedCardPollComponent,
  PollMobilePreviewComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    HttpClientModule,
    FormsModule,
    ACommonModule,
    CommonUiModule,
    RouterModule,
    ImageCropperModule,
    TYTCommonModule,
    ApiModule,
    ValidationModule,
    // routing
  ],
  entryComponents: [
    PollMobilePreviewComponent
  ],
  exports: COMPONENTS,
})
export class PollsModule {
  static forRoot(): ModuleWithProviders<PollsModule> {
    return {
        ngModule: PollsModule,
        providers: []
    };
}
}
